import { SVGProps, Ref, forwardRef } from 'react';

export const OneCBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12.337 6.19c3.197 0 5.803 2.57 5.834 5.74h-1.548c-.033-2.32-1.942-4.2-4.286-4.2-2.364 0-4.287 1.911-4.287 4.26a4.26 4.26 0 0 0 2.491 3.866c.084.039.41.158.49.18a7 7 0 0 0 1.42.233c.139.01.758.016.899.016h10.648v1.533H13.333c-.198-.002-.871-.008-1.064-.023a8.8 8.8 0 0 1-1.73-.3 7 7 0 0 1-.962-.4C7.748 16.115 6.5 14.197 6.5 11.99c0-3.198 2.618-5.8 5.836-5.8"
                fill="#D91920"
            />
            <path d="M3.208 17.812H1.71V9.996H-.002v-1.49h3.21z" fill="#D91920" />
            <path d="M5.547 17.812H3.988V7.732H1.71v-1.55h3.837z" fill="#D91920" />
            <path
                d="M12.337 8.677c1.821 0 3.3 1.451 3.331 3.254h-1.487a1.84 1.84 0 0 0-1.844-1.776 1.84 1.84 0 0 0-1.845 1.836c0 .697.392 1.301.967 1.61.082.046.264.114.457.165.172.04.44.067.624.083.11.01.699.013.81.013h10.647v1.48H13.306v-.001c-.128-.002-.73-.006-.854-.016a6.4 6.4 0 0 1-1.051-.16 3 3 0 0 1-.57-.22 3.31 3.31 0 0 1-1.83-2.954c0-1.832 1.495-3.314 3.336-3.314"
                fill="#D91920"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.332 6.792c.098 0 .334.033.334.292 0 .064-.016.17-.178.226.13.042.146.147.146.259.016.154 0 .186.04.227h-.186c-.041-.024-.042-.055-.042-.227 0-.088-.016-.186-.228-.186h-.148v.413h-.186V6.792zm-.262.129v.317h.22c.156 0 .19-.09.19-.154 0-.122-.09-.163-.22-.163z"
                fill="#D91920"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.242 6.29c.58 0 1.027.445 1.027 1.004s-.447 1.02-1.027 1.02a1.03 1.03 0 0 1-1.027-1.02c0-.56.466-1.004 1.027-1.004m0 .162c-.463 0-.863.372-.864.842 0 .493.401.857.864.857a.854.854 0 0 0 .863-.857c0-.47-.399-.842-.863-.842"
                fill="#D91920"
            />
        </g>
    </svg>
));
OneCBrandSize24Glyph.displayName = 'OneCBrandSize24Glyph';
